// extracted by mini-css-extract-plugin
export default {"root":"index_root__ligrc","opBtn":"index_opBtn__K5VnO","divider":"index_divider__JrcQC"};